import { render, staticRenderFns } from "./GroupMemberEditDialog.vue?vue&type=template&id=995bf66a&"
import script from "./GroupMemberEditDialog.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports